import './app.scss';
import {
    HashRouter as Router,
    Route,
    Switch
} from 'react-router-dom';
import RegisterParticipantPage from 'src/pages/register-participant';
import { useEffect } from 'react';
import packageInfo from '../../../package.json';
import { NotFoundPage } from 'src/pages/not-found';
import RegisterCallPage from 'src/pages/register-call';
import RegisterCallSourcePage from 'src/pages/register-call-source';

const version = packageInfo.version;

const App = () => {
    useEffect(() => {
        const blocker = (event: PopStateEvent) => {
            event.preventDefault();
            window.history.pushState(null, document.title, window.location.href);
        };

        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', blocker);

        return () => {
            window.removeEventListener('popstate', blocker);
        };
    }, []);

    return <div className='vb-d-flex vb-flex-column vb-h-100 vb-overflow-auto vb-w-100 vb-vb-registrator'>
        <Router>
            <Switch>
                <Route path="/participant/register/:callHash?" component={RegisterParticipantPage} />
                <Route path="/call/register/source/:sourceHash?" component={RegisterCallSourcePage} />
                <Route path="/call/register" component={RegisterCallPage} />
                <Route component={NotFoundPage} />
            </Switch>
        </Router>
        <div className='vb-version'>{version}</div>
    </div>;
};

export default App;
